export const samplingTypeOptions = [
  { value: 'Standard', label: 'Standard' },
  { value: 'Alternate1', label: 'Alternate 1' },
  { value: 'Atlernate2', label: 'Alternate 2 / Focus' }
];

export const followupFrequencyOptions = [
  { value: 'EveryWeek', label: 'Every Week' },
  { value: 'EveryTwoDays', label: 'Every 2 Days' },
  { value: 'Monthly', label: 'Monthly' }
];

// The settings forms save 'Atlernate2', but 'Alternate2' also shows up in saved data
const samplingTypeAliases = { 'Alternate2': 'Atlernate2' };

function labelFor(options, value) {
  const option = options.find(ele => ele.value === value);
  return option ? option.label : (value || '');
}

export function getSamplingTypeLabel(value) {
  return labelFor(samplingTypeOptions, samplingTypeAliases[value] || value);
}

export function getFollowupFrequencyLabel(value) {
  return labelFor(followupFrequencyOptions, value);
}

function formatDate(dateString) {
  const month = dateString.substring(0, 2);
  const day = dateString.substring(2, 4);
  const year = dateString.substring(4, 8);
  return `${year}-${month}-${day}`;
}

export function formatResponse(responseData, schoolList, apiFor) {
  const formatted_data = responseData.map(entry => {
    let studentName = "";
    let currentEligibility = "";
    let category = "";

    // Extracting student name from householdAppInfo
    const studentInfo = entry.householdAppInfo.find(info => info.personType === "Student");
    if (studentInfo) {
        studentName = `${studentInfo.fname} ${studentInfo.mname ? studentInfo.mname + ' ' :''}${studentInfo.lname}`;
    }

    // Determining current eligibility
    if (studentInfo && studentInfo.isFreeMeal !== null) {
        currentEligibility = studentInfo.isFreeMeal ? "Free" : "Reduced";
    } else if (studentInfo) {
        currentEligibility = "Regular";
    }

   
  if(entry.errorProne){
    category = 'errorProne'
  }
  else if (studentInfo.assistancePrograms){
    const assistanceProgram = studentInfo.assistancePrograms.find(program => program.isApplicable);
      if(assistanceProgram){
          category = assistanceProgram.accronym
      }
    }else{
        category = 'Income'
      }
      
    // get schoolName from ID
    let schoolObject = schoolList.find(obj => obj.schoolId === entry.mealSchoolId);

        if (apiFor === "getApplications") {
       
            return {
                "applicationId": entry.applicationId,
                "appliedDate": formatDate(entry.date),
                "schoolName": schoolObject.schoolName,
                "studentName": studentName,
                "currentEligibility": currentEligibility,
                "applicationCategory": category.toUpperCase(),
                "errorProne": category == 'errorProne' ? 'Yes' : 'No',
                "status": entry.status,
            }
        
        } else { 
            return {
            
                "applicationId": entry.applicationId,
                "appliedDate": formatDate(entry.date),
                "schoolName": schoolObject.schoolName,
                "mealSchoolId": schoolObject.schoolId,
                "studentName": studentName,
                "currentEligibility": currentEligibility,
                "applicationCategory": category.toUpperCase(),
                "errorProne": category == 'errorProne' ? 'Yes' : 'No',
                "action": "add"
            }
        }
});
  
  return formatted_data;
}


export function formatHouseholdAppsVerifyResponse(apiResponse) { 
  
  const reviewData = [];

  apiResponse.forEach(item => {
    const reviewItem = {
      verifyId: item.verifyId,
      applicationId: item.applicationId,
      applicationCategory: item.applicationCategory,
      appliedDate: item.appliedDate,
      currentEligibility: item.currentEligibility,
      confirmOfficialSign: item.confirmOfficialSign,
      directVerification: item.directVerification,
      verificationLetterSent: item.verificationLetterSent,
      //eligibilityConfirmed: item.eligibilityConfirmed ? "yes" : "no",
      //dvDone: item.dvDone ? "yes" : "no",
      documentsReceived: item.documentsReceived,
      documentsVerified: item.documentsVerified,
      documentVerifiedStatus: item.documentsVerified ? "Verified" : "No Response",
      lastFollowUp: item.lastFollowUpDate,
      newEligibility: item.newEligibility !== undefined ? item.newEligibility : "",
      notes: item.notesAndDocs.filter(item => item.inputType === 'note'),
      documents: item.notesAndDocs.filter(item => item.inputType === 'document'),
      status: item.status !== undefined ? item.status : ""
    };

  
    reviewData.push(reviewItem);
  });


  return reviewData;

}

export function selectedRowUpdatedObj(response) { 
  const notes = response.notesAndDocs.filter(item => item.inputType === 'note')
  const docs = response.notesAndDocs.filter(item => item.inputType === 'document')
  const { notesAndDocs, ...rest } = response
  rest.notes = notes
  rest.documents = docs
  const finalResult = { '_original': rest }
  return finalResult
}


export function calculateCounts(apiResponse) {
  // Initializing count variables
  let errorProneCount = 0;
  let caseCount = 0;
  let incomeCount = 0;
  let currentStatusFree = 0;
  let currentStatusReduced = 0;
  let newStatusFree = 0;
  let newStatusReduced = 0;
  let responseReceived = 0;
  let pendingResponses = 0;

  // Iterating through the response array
  apiResponse.forEach((item) => {
    switch (item.applicationCategory.toLowerCase()) {
      case 'errorprone':
        errorProneCount++;
        break;
      case 'case':
        caseCount++;
        break;
      case 'income':
        incomeCount++;
        break;
    }
    switch (item.currentEligibility.toLowerCase()) {
      case 'free':
        currentStatusFree++;
        break;
      case 'reduced':
        currentStatusReduced++;
        break;
    }
    switch (item.newEligibility) {
      case 'Free':
        newStatusFree++;
        break;
      case 'Reduced':
        newStatusReduced++;
        break;
      case undefined:
        break;
    }
    switch (item.documentsReceived) {
      case true:
        responseReceived++;
        break;
      default:
        pendingResponses++;
        break;
    }
  });

  // Calculating total count
  const totalCount = apiResponse.length;

  return {
    errorProneCount,
    caseCount,
    incomeCount,
    totalCount,
    currentStatusFree,
    currentStatusReduced,
    newStatusFree,
    newStatusReduced,
    responseReceived,
    pendingResponses
  };
}


// WEBPACK FOOTER //
// ./src/components/District/applicationVerification/utils.js